module.exports = "images/miscellaneous_a.a35625113f1bbebe829e3cbef380a3da.png";